module.exports = __webpack_public_path__ + "static/sporten-f53066d73e4e0aed77b57c5773d3b96d.svg";